module.exports = __webpack_public_path__ + "img/ANGOLI-DEFINITIVI_POSTER.96c946fe.jpg";